/* Long FAQ lists: show the first 6, then "Show all N questions".
   Hidden answers stay in the page, so search and AI crawlers still read them. */
(function () {
  var SHOW = 6;
  function init() {
    document.querySelectorAll('.faq-accordion-items').forEach(function (list) {
      var items = Array.prototype.filter.call(list.children, function (c) {
        return c.classList.contains('faq-accordion-item');
      });
      if (items.length <= SHOW + 2 || list.dataset.snFaq) return;
      list.dataset.snFaq = '1';
      items.slice(SHOW).forEach(function (i) { i.classList.add('sn-faq-extra'); });
      list.classList.add('sn-faq-collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sn-faq-more';
      btn.textContent = 'Show all ' + items.length + ' questions';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('sn-faq-collapsed') === false;
        btn.textContent = open ? 'Show fewer' : 'Show all ' + items.length + ' questions';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      list.parentNode.insertBefore(btn, list.nextSibling);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
